import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Pricing() {
  const handlePurchase = () => {
    window.location.href = 'https://miguiaclara.com/cart/50831423799586:1';
  };
  return <Section id="pricing" className="bg-white" data-id="element-76">
      <div className="max-w-lg mx-auto bg-white rounded-3xl shadow-xl border border-brand-light overflow-hidden" data-id="element-77">
        <div className="bg-brand-primary p-6 text-center text-white" data-id="element-78">
          <h3 className="text-2xl font-serif" data-id="element-79">Plan Biohacking Exprés</h3>
          <p className="text-white/80" data-id="element-80">Acceso inmediato al PDF + Bonus</p>
        </div>

        <div className="p-8 md:p-10 text-center" data-id="element-81">
          <div className="flex justify-center items-baseline mb-2" data-id="element-82">
            <span className="text-sm text-gray-500 mr-2" data-id="element-83">ARS</span>
            <span className="text-5xl font-bold text-brand-text" data-id="element-84">19.000</span>
          </div>
          <p className="text-gray-500 mb-8 text-sm" data-id="element-85">
            Pago único. Sin suscripciones.
          </p>

          <Button fullWidth size="lg" className="text-lg shadow-brand-primary/30 shadow-lg" onClick={handlePurchase} data-id="element-86">
            Quiero mi plan de 21 días
          </Button>

          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-gray-500" data-id="element-87">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-88" />
            <span data-id="element-89">Compra segura y encriptada</span>
          </div>
        </div>
      </div>
    </Section>;
}